import script from "./MediaTagForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaTagForm.vue?vue&type=script&setup=true&lang=js"

import "./MediaTagForm.vue?vue&type=style&index=0&id=319b78dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319b78dc"]])

export default __exports__